"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafelistStatus = exports.TokenStandard = exports.AssetContractType = exports.FeeMethod = exports.OrderSide = exports.Chain = exports.EventType = void 0;
/**
 * Events emitted by the SDK which can be used by frontends applications
 * to update state or show useful messages to users.
 * @category Events
 */
var EventType;
(function (EventType) {
    /**
     * Emitted when the transaction is sent to the network and the application
     * is waiting for the transaction to be mined.
     */
    EventType["TransactionCreated"] = "TransactionCreated";
    /**
     * Emitted when the transaction has succeeded is mined and confirmed.
     */
    EventType["TransactionConfirmed"] = "TransactionConfirmed";
    /**
     * Emitted when the transaction has failed to be submitted.
     */
    EventType["TransactionDenied"] = "TransactionDenied";
    /**
     * Emitted when the transaction has failed to be mined.
     */
    EventType["TransactionFailed"] = "TransactionFailed";
    /**
     * Emitted when the {@link OpenSeaSDK.wrapEth} method is called.
     */
    EventType["WrapEth"] = "WrapEth";
    /**
     * Emitted when the {@link OpenSeaSDK.unwrapWeth} method is called.
     */
    EventType["UnwrapWeth"] = "UnwrapWeth";
    /**
     * Emitted when fulfilling a public or private order.
     */
    EventType["MatchOrders"] = "MatchOrders";
    /**
     * Emitted when the {@link OpenSeaSDK.cancelOrder} method is called.
     */
    EventType["CancelOrder"] = "CancelOrder";
    /**
     * Emitted when the {@link OpenSeaSDK.approveOrder} method is called.
     */
    EventType["ApproveOrder"] = "ApproveOrder";
})(EventType || (exports.EventType = EventType = {}));
/**
 * Each of the possible chains that OpenSea supports.
 */
var Chain;
(function (Chain) {
    // Mainnet Chains
    /** Ethereum */
    Chain["Mainnet"] = "ethereum";
    /** Polygon */
    Chain["Polygon"] = "matic";
    /** Klaytn */
    Chain["Klaytn"] = "klaytn";
    /** Base L2 */
    Chain["Base"] = "base";
    /** Binance Smart Chain */
    Chain["BNB"] = "bsc";
    /** Arbitrum */
    Chain["Arbitrum"] = "arbitrum";
    /** Arbitrum Nova */
    Chain["ArbitrumNova"] = "arbitrum_nova";
    /** Avalanche */
    Chain["Avalanche"] = "avalanche";
    /** Optimism */
    Chain["Optimism"] = "optimism";
    /** Solana */
    Chain["Solana"] = "solana";
    /** Zora */
    Chain["Zora"] = "zora";
    // Testnet Chains
    // ⚠️NOTE: When adding to this list, also add to the util function `isTestChain`
    /** Goerli */
    Chain["Goerli"] = "goerli";
    /** Sepolia */
    Chain["Sepolia"] = "sepolia";
    /** Polygon Testchain Mumbai */
    Chain["Mumbai"] = "mumbai";
    /** Klaytn Baobab */
    Chain["Baobab"] = "baobab";
    /** Base L2 Testnet */
    Chain["BaseGoerli"] = "base_goerli";
    /** Binance Smart Chain Testnet */
    Chain["BNBTestnet"] = "bsctestnet";
    /** Arbitrum Testnet */
    Chain["ArbitrumSepolia"] = "arbitrum_sepolia";
    /** Avalanche Fuji Testnet */
    Chain["Fuji"] = "avalanche_fuji";
    /** Optimism Goerli Testnet */
    Chain["OptimismGoerli"] = "optimism_goerli";
    /** Solana Devnet */
    Chain["SolanaDevnet"] = "soldev";
    /** Zora Testnet */
    Chain["ZoraTestnet"] = "zora_testnet";
})(Chain || (exports.Chain = Chain = {}));
/**
 * Seaport order side: buy or sell.
 */
var OrderSide;
(function (OrderSide) {
    OrderSide[OrderSide["Buy"] = 0] = "Buy";
    OrderSide[OrderSide["Sell"] = 1] = "Sell";
})(OrderSide || (exports.OrderSide = OrderSide = {}));
/**
 * Fee method
 * ProtocolFee: Charge maker fee to seller and charge taker fee to buyer.
 * SplitFee: Maker fees are deducted from the token amount that the maker receives. Taker fees are extra tokens that must be paid by the taker.
 */
var FeeMethod;
(function (FeeMethod) {
    FeeMethod[FeeMethod["ProtocolFee"] = 0] = "ProtocolFee";
    FeeMethod[FeeMethod["SplitFee"] = 1] = "SplitFee";
})(FeeMethod || (exports.FeeMethod = FeeMethod = {}));
/**
 * Types of asset contracts
 * Given by the asset_contract_type in the OpenSea API
 */
var AssetContractType;
(function (AssetContractType) {
    AssetContractType["Fungible"] = "fungible";
    AssetContractType["SemiFungible"] = "semi-fungible";
    AssetContractType["NonFungible"] = "non-fungible";
    AssetContractType["Unknown"] = "unknown";
})(AssetContractType || (exports.AssetContractType = AssetContractType = {}));
/**
 * Token standards
 */
var TokenStandard;
(function (TokenStandard) {
    TokenStandard["ERC20"] = "ERC20";
    TokenStandard["ERC721"] = "ERC721";
    TokenStandard["ERC1155"] = "ERC1155";
})(TokenStandard || (exports.TokenStandard = TokenStandard = {}));
/**
 * The collection's approval status within OpenSea.
 * Can be not_requested (brand new collections)
 * requested (collections that requested safelisting on our site)
 * approved (collections that are approved on our site and can be found in search results)
 * verified (verified collections)
 */
var SafelistStatus;
(function (SafelistStatus) {
    SafelistStatus["NOT_REQUESTED"] = "not_requested";
    SafelistStatus["REQUESTED"] = "requested";
    SafelistStatus["APPROVED"] = "approved";
    SafelistStatus["VERIFIED"] = "verified";
    SafelistStatus["DISABLED_TOP_TRENDING"] = "disabled_top_trending";
})(SafelistStatus || (exports.SafelistStatus = SafelistStatus = {}));
/**
 * Defines set of possible auctions types
 */
var AuctionType;
(function (AuctionType) {
    AuctionType["Dutch"] = "dutch";
    AuctionType["English"] = "english";
    AuctionType["MinPrice"] = "min_price";
})(AuctionType || (AuctionType = {}));
/**
 * Defines the possible types of asset events that can take place
 */
var AssetEventType;
(function (AssetEventType) {
    AssetEventType["AuctionCreated"] = "created";
    AssetEventType["AuctionSuccessful"] = "successful";
    AssetEventType["AuctionCancelled"] = "cancelled";
    AssetEventType["OfferEntered"] = "offer_entered";
    AssetEventType["BidEntered"] = "bid_entered";
    AssetEventType["BidWithdraw"] = "bid_withdraw";
    AssetEventType["AssetTransfer"] = "transfer";
    AssetEventType["AssetApprove"] = "approve";
    AssetEventType["CompositionCreated"] = "composition_created";
    AssetEventType["Custom"] = "custom";
    AssetEventType["Payout"] = "payout";
})(AssetEventType || (AssetEventType = {}));
//# sourceMappingURL=types.js.map